module.exports = __webpack_public_path__ + "static/media/passive-income.8e348c61.svg";